import { createContext, useContext } from "react";

type ObjectType = Record<string, unknown>;

function createContextSet<A extends ObjectType | null>() {
  const ctx = createContext<A | undefined>(undefined);
  function useCtx() {
    const c = useContext(ctx);
    if (c === undefined)
      throw new Error("useCtx must be inside a Provider with a value");
    return c;
  }
  return [useCtx, ctx.Provider] as const;
}

export default createContextSet;
